import { TmdxTextarea } from '@ds';
import { AdminFormRow, AdminFormSection } from '@ui';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DriverFormType } from '@/api/apis/resources';
import { isFieldRequired } from '@/utils/helpers';
import { bannedDriversFormSchema } from './config';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';
import { AffiliationSection } from './components/AffiliationSection';
import { ControlledTextInput } from '../components/inputs/ControlledTextInput';
import { ControlledPhoneInput } from '../components/inputs/ControlledPhoneInput';

type BannedDriversProps = {
  isReadOnly?: boolean;
};

export const BannedDriversForm = memo(({ isReadOnly = false }: BannedDriversProps) => {
  const { control } = useFormContext<DriverFormType>(); // needed for TmdxTextarea

  return (
    <AdminFormSection title="Driver details">
      <AdminFormRow title="First Name" isRequired={isFieldRequired(bannedDriversFormSchema, 'firstName')} gap="md">
        <ControlledTextInput name="firstName" aria-label="First name" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="Last Name" isRequired={isFieldRequired(bannedDriversFormSchema, 'lastName')} gap="md">
        <ControlledTextInput name="lastName" aria-label="Last name" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AffiliationSection isReadOnly={isReadOnly} />
      <AdminFormRow
        title="Phone number"
        inputWrapperClass="max-w-[20rem]"
        isRequired={isFieldRequired(bannedDriversFormSchema, 'phone')}
        gap="md"
      >
        <ControlledPhoneInput name="phone" disabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow
        title="Comment"
        center={false}
        gap="md"
        isRequired={isFieldRequired(bannedDriversFormSchema, 'comment')}
      >
        <Controller
          name="comment"
          control={control}
          render={({ field, fieldState: { invalid, error } }) => (
            <TmdxTextarea
              fullWidth
              disableAnimation
              minRows={2}
              placeholder="Add comment"
              isInvalid={invalid}
              errorMessage={error?.message}
              className="min-h-16"
              maxLength={MAX_LENGTH_2000}
              {...field}
            />
          )}
        />
      </AdminFormRow>
    </AdminFormSection>
  );
});
